<template>
  <component :is="tag" v-if="iframeUrl">
    <div class="section-inner">
      <iframe
        class="iframe"
        width="100%"
        :src="iframeUrl"
        frameborder="0"
      ></iframe>
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});

const iframeUrl = computed(() => {
  return props.blok.iframe_url;
});
</script>

<style lang="scss" scoped>
.iframe {
  aspect-ratio: 9/16;
  width: 100%;
  overflow-y: auto;
  @include for-desktop-up {
    aspect-ratio: 16/9;
  }
}
</style>
